import { INTERNAL_DIMENSIONS, type DisplayDimension, type InternalDimension, type Song } from "../types";

export const DIMENSION_LABELS: Record<InternalDimension, DisplayDimension> = {
  相信: "相信",
  眷恋: "眷恋",
  不服: "倔强",
  远方: "远方",
  孤独: "孤独",
  狂欢: "狂欢",
};

export const DIMENSION_DESCRIPTIONS: Record<InternalDimension, string> = {
  相信: "即使看见现实的重量，仍愿意给人、关系和明天留一点可能。",
  眷恋: "重视关系留下的分量，也愿意承认过去如何参与了今天。",
  不服: "不轻易认输，不会照单全收；面对规则和压力时仍保留自己的判断。",
  远方: "愿意移动、改变和打开下一段，不把现在当成唯一答案。",
  孤独: "重要的感受会先在自己这里停留，也能独自完成一部分思考。",
  狂欢: "容易从现场、同行与共同经历中恢复力量，让身体先替情绪换气。",
};

export function emptyScores(): Record<InternalDimension, number> {
  return Object.fromEntries(INTERNAL_DIMENSIONS.map((dimension) => [dimension, 0])) as Record<InternalDimension, number>;
}

export function sumDimensions(songs: Song[]): Record<InternalDimension, number> {
  const scores = emptyScores();
  for (const song of songs) {
    for (const dimension of INTERNAL_DIMENSIONS) scores[dimension] += song.weights[dimension];
  }
  return scores;
}

export function sortedDimensions(scores: Record<InternalDimension, number>) {
  return [...INTERNAL_DIMENSIONS].sort((left, right) => scores[right] - scores[left] || INTERNAL_DIMENSIONS.indexOf(left) - INTERNAL_DIMENSIONS.indexOf(right));
}

export function displayDimension(dimension: InternalDimension) {
  return DIMENSION_LABELS[dimension];
}

/** Apply the approved presentation-only rename without mutating audited data. */
export function toDisplayCopy(copy: string) {
  return copy.replaceAll("不服", "倔强");
}
